import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Popup from "../../../../components/popup/Popup";
import { useState } from "react";
import useClickOutside from "../../../../Hooks/useClickOutside";
import ReviewReport from "../../../../components/common/ReportForm/ReviewReport";
import {
  AdminMainText,
  AdminMetadataText,
  AdminFilterChipButton,
  AdminFormSecondaryAction,
  AdminFilterMenuItem,
} from "../../../AdminDashboard/shared/adminUx";
import { Rating } from "primereact/rating";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from 'swiper/modules';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Lightbox from "../../../../components/common/Lightbox/Lightbox";
import { FaRegThumbsUp, FaRegThumbsDown } from "react-icons/fa";
import { BiLike, BiDislike } from "react-icons/bi";

const BusinessReviews = ({ showMeReply, showMeReport, DropdownClasses, starFilter, onClearFilter }) => {
  const navigate = useNavigate();
  const [ShowCrossButton, setShowCrossButton] = useState(true);
  const [report, setReport] = useState(false);
  const [filters, setFilters] = useState(false);
  const ref = useRef(null);
  useClickOutside(ref, () => {
    setFilters(false);
  });
  const [reply, setReply] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  
  // Pagination state
  const [visibleReviewsCount, setVisibleReviewsCount] = useState(4);
  const reviewsPerPage = 4;

  // State for helpful votes for each review
  const [helpfulVotes, setHelpfulVotes] = useState({
    0: { up: 0, down: 0, userVote: null },
    1: { up: 0, down: 0, userVote: null },
    2: { up: 0, down: 0, userVote: null },
    3: { up: 0, down: 0, userVote: null },
    4: { up: 0, down: 0, userVote: null },
    5: { up: 0, down: 0, userVote: null },
    6: { up: 0, down: 0, userVote: null },
    7: { up: 0, down: 0, userVote: null },
    8: { up: 0, down: 0, userVote: null },
    9: { up: 0, down: 0, userVote: null },
  });

  const reviewImages = [
    require("../../../../assets/img/default-image.jpg"),
    require("../../../../assets/img/default-image.jpg"),
    require("../../../../assets/img/default-image.jpg"),
  ];

  // All reviews data with different star ratings
  const allReviews = [
    {
      id: 1,
      name: "Jozeph J",
      location: "Duffy, Australian Capital Territory, 2611",
      rating: 5,
      text: "Donec consequat, lacus vel ornare laoreet, nibh lacus blandit est, venenatis feugiat augue augue eu ipsum. a b c Vestibulum pulvinar eleifend facilisis. Aliquam a tempor orci, vitae ullamcorper mauris.",
      timeAgo: "1 hour ago",
      // hasImages: true,
      tags: ["Plumbing", "Emergency", "24/7 Service"]
    },
    {
      id: 2,
      name: "Sarah M",
      location: "Duffy, Australian Capital Territory, 2611",
      rating: 4,
      text: "Vestibulum pulvinar eleifend facilisis. Aliquam a tempor orci, vitae ullamcorper mauris. Cras sollicitudin turpis quis tempus pretium. Maecenas vehicula mauris sagittis justo blandit.",
      timeAgo: "2 hours ago",
      hasImages: false,
      tags: ["Electrical", "Installation", "Safety Check"]
    },
    {
      id: 3,
      name: "Michael R",
      location: "Duffy, Australian Capital Territory, 2611",
      rating: 3,
      text: "Cras sollicitudin turpis quis tempus pretium. Maecenas vehicula mauris sagittis justo blandit, sed consequat lacus dictum. Sed molestie diam neque, ut consectetur dui iaculis vitae.",
      timeAgo: "3 hours ago",
      hasImages: false,
      tags: ["Carpentry", "Repair", "Custom Work"]
    },
    {
      id: 4,
      name: "Emma L",
      location: "Canberra, Australian Capital Territory, 2600",
      rating: 5,
      text: "Exceptional service! The team went above and beyond my expectations. Professional, punctual, and the quality of work was outstanding. Highly recommend to anyone looking for reliable service.",
      timeAgo: "5 hours ago",
      hasImages: true,
      tags: ["Painting", "Interior", "Premium Finish"]
    },
    {
      id: 5,
      name: "David K",
      location: "Belconnen, Australian Capital Territory, 2617",
      rating: 4,
      text: "Very good experience overall. The work was completed on time and the communication was clear throughout the process. Would definitely use their services again.",
      timeAgo: "1 day ago",
      hasImages: false,
      tags: ["Landscaping", "Design", "Maintenance"]
    },
    {
      id: 6,
      name: "Lisa P",
      location: "Woden, Australian Capital Territory, 2606",
      rating: 2,
      text: "The service was okay but not great. There were some delays and the final result wasn't exactly what I expected. Communication could have been better.",
      timeAgo: "2 days ago",
      hasImages: false,
      tags: ["Cleaning", "Regular", "Deep Clean"]
    },
    {
      id: 7,
      name: "John S",
      location: "Tuggeranong, Australian Capital Territory, 2900",
      rating: 5,
      text: "Absolutely fantastic! The attention to detail was incredible and the team was so professional. The end result exceeded all my expectations. Thank you!",
      timeAgo: "3 days ago",
      hasImages: true,
      tags: ["Roofing", "Repair", "Emergency"]
    },
    {
      id: 8,
      name: "Maria G",
      location: "Gungahlin, Australian Capital Territory, 2912",
      rating: 1,
      text: "Very disappointed with the service. Poor communication, delays, and the quality was not up to standard. Would not recommend.",
      timeAgo: "4 days ago",
      hasImages: false,
      tags: ["HVAC", "Installation", "Service"]
    },
    {
      id: 9,
      name: "Robert T",
      location: "Fyshwick, Australian Capital Territory, 2609",
      rating: 4,
      text: "Good quality work and reasonable pricing. The team was friendly and professional. Minor delays but overall satisfied with the result.",
      timeAgo: "5 days ago",
      hasImages: false,
      tags: ["Flooring", "Installation", "Hardwood"]
    },
    {
      id: 10,
      name: "Anna W",
      location: "Braddon, Australian Capital Territory, 2612",
      rating: 3,
      text: "Average experience. The work was completed but there were some issues that needed to be addressed. Service was okay but could be improved.",
      timeAgo: "1 week ago",
      hasImages: false,
      tags: ["Tiling", "Bathroom", "Kitchen"]
    },
  ];

  // Filter reviews based on starFilter
  const filteredReviews = starFilter 
    ? allReviews.filter(review => review.rating === starFilter)
    : allReviews;

  // Get visible reviews based on pagination
  const visibleReviews = filteredReviews.slice(0, visibleReviewsCount);
  const hasMoreReviews = visibleReviewsCount < filteredReviews.length;

  useEffect(() => {
    if (report || reply) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }
  }, [report, reply]);

  // Reset visible reviews count when filter changes
  useEffect(() => {
    setVisibleReviewsCount(4);
  }, [starFilter]);

  const handleImageClick = (idx) => {
    setImageIndex(idx);
    setShowPreview(true);
  };

  const handleHelpfulVote = (reviewIndex, voteType) => {
    setHelpfulVotes(prev => {
      const currentReview = prev[reviewIndex];
      const newVote = currentReview.userVote === voteType ? null : voteType;
      
      let newUp = currentReview.up;
      let newDown = currentReview.down;
      
      // Remove previous vote if exists
      if (currentReview.userVote === 'up') newUp--;
      if (currentReview.userVote === 'down') newDown--;
      
      // Add new vote
      if (newVote === 'up') newUp++;
      if (newVote === 'down') newDown++;
      
      return {
        ...prev,
        [reviewIndex]: {
          up: newUp,
          down: newDown,
          userVote: newVote
        }
      };
    });
  };

  const handleLoadMore = () => {
    setVisibleReviewsCount(prev => prev + reviewsPerPage);
  };

  const handleTagClick = () => {
    navigate('/category/plumbing');
  };

  return (
    <>
      <div className="max-w-full md:max-w-full xl:max-w-full 2xl:max-w-full text-offblack rounded-3xl pb-5 pt-5 xl:pb-[50px]">
        <div className="flex justify-between items-center" ref={ref}>
            <div className="flex items-center gap-2">
                              {starFilter && (
                  <AdminFilterChipButton type="button" onClick={onClearFilter} className="!w-auto gap-2">
                    <span>Showing {starFilter}-star reviews</span>
                    <i className="fi fi-rs-cross text-sm" aria-hidden />
                  </AdminFilterChipButton>
                )}
            </div>
          <div className="relative w-fit">
            {/* <MainButton
              variant={"smallbetween"}
              onClick={() => setFilters(!filters)}
            >
              Latest
              <i
                className={
                  filters
                    ? "fi fi-rs-angle-up text-[14px] lg:text-sm cursor-pointer flex items-center"
                    : "fi fi-rs-angle-down text-[14px] lg:text-sm cursor-pointer flex items-center"
                }
              ></i>
            </MainButton> */}

            {filters && (
              <div
                className={`flex flex-col rounded-xl w-[150px] sm:w-[150px] md:w-[150px] h-auto gap-3 absolute z-10 mt-3 text-offblack py-5 px-3 ${DropdownClasses} right-0`}
              >
                <AdminFilterMenuItem type="button" onClick={() => setFilters(false)}>
                  Lowest
                </AdminFilterMenuItem>
                <AdminFilterMenuItem type="button" onClick={() => setFilters(false)}>
                  Highest
                </AdminFilterMenuItem>
                <AdminFilterMenuItem type="button" onClick={() => setFilters(false)}>
                  Earliest
                </AdminFilterMenuItem>
              </div>
            )}
          </div>
        </div>

        {/* Reviews List - Two Column Layout */}
        {visibleReviews.length > 0 ? (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {visibleReviews.map((review, index) => (
              <div 
                key={review.id} 
                className={`${index < visibleReviews.length - 2 ? 'border-b border-b-mediumgray pb-6 mt-0' : 'pb-6 mt-0'}`}
              >
              <div className="flex gap-x-3">
                <div className="w-10 sm:w-12 shrink-0">
                  <img
                    className="size-10 sm:size-12 object-cover rounded-full"
                    src={require("../../../../assets/img/User.png")}
                    alt={"no"}
                  />
                </div>
                <div className="mt-1 w-full">
                  <AdminMainText className="text-offblack">{review.name}</AdminMainText>
                  <div className="mt-1">
                    <AdminMetadataText className="text-offblack block">
                      {review.location}
                    </AdminMetadataText>
                  </div>

                  <div className="mt-2">
                    <AdminMainText className="text-offblack block">{review.text}</AdminMainText>

                    {/* Review Tags - Show after text for all reviews */}
                    {review.tags && review.tags.length > 0 && (
                      <div className="mt-3">
                        <div className="flex flex-wrap gap-2">
                          {review.tags.map((tag, tagIndex) => (
                            <span 
                              key={tagIndex} 
                              className="border border-solid border-mediumgray rounded-[4px] px-2 py-1 mr-2 cursor-pointer transition-all duration-200 hover:bg-offblack hover:text-white hover:border-offblack"
                              onClick={handleTagClick}
                            >
                              {tag}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Review Images */}
                    {review.hasImages && (
                      <div className="grid grid-cols-5 gap-4 mt-4 mb-4">
                        {reviewImages.map((image, imgIndex) => (
                          <div key={imgIndex} className="aspect-[150/100] cursor-pointer" onClick={() => handleImageClick(imgIndex)}>
                            <img
                              src={image}
                              alt={`Review image ${imgIndex + 1}`}
                              className="w-full h-full object-cover rounded-lg"
                            />
                          </div>
                        ))}
                      </div>
                    )}

                    {showPreview && (
                      <Lightbox
                        images={reviewImages}
                        initialIndex={imageIndex}
                        onClose={() => setShowPreview(false)}
                      />
                    )}
                    
                    <div className="flex items-center gap-2 mt-4">
                      <div className="flex items-center">
                        <Rating
                          value={review.rating}
                          stars={1}
                          style={{ gap: 5 }}
                          cancel={false}
                          defaultValue={review.rating}
                        />
                        <AdminMetadataText className="ml-1 text-offblack">
                          {review.rating.toFixed(1)}
                        </AdminMetadataText>
                      </div>
                      <div className="mx-2">
                        <i className="fi fi-ss-bullet text-[10px] text-offblack"></i>
                      </div>
                      <div>
                        <AdminMetadataText className="text-offblack">
                          {review.timeAgo}
                        </AdminMetadataText>
                      </div>
                      <div className="mx-2">
                        <i className="fi fi-ss-bullet text-[10px] text-offblack"></i>
                      </div>
                      <button
                        type="button"
                        onClick={() => setReport(true)}
                        className="text-offblack hover:underline"
                      >
                        <AdminMetadataText className="text-offblack">Report</AdminMetadataText>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-10">
            <AdminMetadataText className="text-mediumgray block">
              No reviews found for {starFilter}-star rating
            </AdminMetadataText>
          </div>
        )}

        {/* Load More Button */}
        {hasMoreReviews && (
          <div className="flex justify-center mt-8">
            <AdminFormSecondaryAction type="button" onClick={handleLoadMore}>
              Load more
            </AdminFormSecondaryAction>
          </div>
        )}
      </div>

      {report && (
        <Popup setTrigger={setReport} onClose={() => setReport(false)}>
          <ReviewReport closePopup={() => setReport(false)} />
        </Popup>
      )}
    </>
  );
};

export default BusinessReviews;
